import { forwardRef, Ref } from 'react';

type OptionListProps = {
  children: React.ReactNode;
};

const OptionList = (props: OptionListProps, ref: Ref<HTMLUListElement>) => {
  return (
    <ul ref={ref} className="rounded-[8px] p-[8px] surface_primary shadow-menu">
      {props.children}
    </ul>
  );
};

export default forwardRef(OptionList);
